var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { businessService } from "~/config/server";
import { NetService } from "~/utils/net.service";
import { Inject, Debounce } from "~/core/decorator";
import { Service } from "~/core/service";
var WorkOrderService = /** @class */ (function (_super) {
    __extends(WorkOrderService, _super);
    function WorkOrderService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 添加工单
     */
    WorkOrderService.prototype.addWorkOrder = function (data, loading) {
        return this.netService.send({
            server: businessService.workOrderController.addWorkOrder,
            data: data,
            loading: loading
        });
    };
    /**
     * 查询工单
     */
    WorkOrderService.prototype.findAllWorkOrder = function (data, page, sort, loading) {
        return this.netService.send({
            server: businessService.workOrderController.findAllWorkOrder,
            data: data,
            page: page,
            sort: sort,
            loading: loading
        });
    };
    /**
     * 修改工单
     */
    WorkOrderService.prototype.modifyWorkOrder = function (data, loading) {
        return this.netService.send({
            server: businessService.workOrderController.modifyWorkOrder,
            data: data,
            loading: loading
        });
    };
    /**
     * 删除工单
     */
    WorkOrderService.prototype.deleteWorkOrder = function (id, loading) {
        return this.netService.send({
            server: businessService.workOrderController.deleteWorkOrder,
            data: {
                id: id
            },
            loading: loading
        });
    };
    __decorate([
        Inject(NetService)
    ], WorkOrderService.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], WorkOrderService.prototype, "addWorkOrder", null);
    __decorate([
        Debounce()
    ], WorkOrderService.prototype, "findAllWorkOrder", null);
    __decorate([
        Debounce()
    ], WorkOrderService.prototype, "modifyWorkOrder", null);
    __decorate([
        Debounce()
    ], WorkOrderService.prototype, "deleteWorkOrder", null);
    return WorkOrderService;
}(Service));
export { WorkOrderService };
